import React, { useEffect, useState } from "react";
import axios from "axios";
const UserContext = React.createContext();
export const UserProvider = (props) => {
  const ambilToken = localStorage.getItem("token");
  const [token, setToken] = useState(ambilToken);
  const [user, setUser] = useState({});
  const [login, setLogin] = useState(!!token);
  const [loading, setLoading] = useState(false);

  /* login tergantung token
     jika token ada, login true, tapi jika token tidak ada maka login false */
  const fetchData = async () => {
    setLoading(true);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    await axios
      .get(process.env.REACT_APP_LINK_API + "user")
      .then((response) => {
        // jika berhasil
        setLogin(true);
        setUser({ nama: response.data.name, id: response.data.id });
      })
      .catch((e) => {
        alert("Authentikasi error, silahkan login kembali");
        localStorage.removeItem("token");
        setLogin(false);
        // history.push("/login");
      });
    setLoading(false);
  };

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, []);

  const masukLogin = (data) => {
    localStorage.setItem("token", data.token);
    setToken(data.token);
    setLogin(true);
    setUser({ nama: data.user.name, id: data.user.id });
  };

  const keluar = () => {
    setToken(false);
    setLogin(false);
    localStorage.removeItem("token");
  };

  return (
    <UserContext.Provider
      value={{
        login: login,
        user: user,
        loading: loading,
        loginHandler: masukLogin,
        logoutHandler: keluar,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};
export default UserContext;
